import React from "react";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";
import Expander from "../../../../../components/Expander";

export const getDrugsTable = (items) => {
  if (Array.isArray(items) && items.length !== 0) {
    const result = (
      <table className="varsome-table">
        <thead>
          <tr>
            <th>Therapeutic Context</th>
            <th>Pathway</th>
            <th>Effect</th>
            <th>Status</th>
            <th>Evidence</th>
            <th>Source</th>
          </tr>
        </thead>
        <Expander showMore="10" component="tbody">
          {items.map((item, i) => (
            <tr key={`drug-${i}`}>
              <td className="tw-p-2.5">
                {item.therapeutic_context ? item.therapeutic_context : "-"}
              </td>
              <td className="tw-p-2.5">{item.pathway ? item.pathway : "-"}</td>
              <td className="tw-p-2.5">{item.effect ? item.effect : "-"}</td>
              <td className="tw-p-2.5">{item.status ? item.status : "-"}</td>
              <td className="tw-p-2.5">
                {item.evidence ? item.evidence : "-"}
              </td>
              <td className="tw-p-2.5">
                {item.pub_med_references ? (
                  <PublicationLinks limit={10} ids={item.pub_med_references} />
                ) : (
                  item.source
                )}
              </td>
            </tr>
          ))}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
